import React from 'react';

interface PageLayoutProps {
  children: React.ReactNode;
}

// Default container for "/app/*" pages that don't have their own settings
// chrome. Keeps a clean shadcn-style background while letting the page own
// its inner layout.
export default function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <main className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6">{children}</main>
    </div>
  );
}
